'use client'
// pages/protein/layout.tsx
import Link from 'next/link';
import { ReactNode } from 'react';
import { usePathname } from 'next/navigation';  // Use the Next.js hook to get the current path

interface LayoutProps {
  children: ReactNode;
}

const ProteinPageLayout = ({ children }: LayoutProps) => {
  const pathname = usePathname(); // Get the current path

  // Skip layout for the specific search page
  if (pathname.includes('protein/blast/search')) {
    return <>{children}</>; // Just return children without the layout
  }

  
  return (
    <div className="container mx-auto px-4 py-8">
      {/* Back to Search Link */}
      <div className="mb-6">
        <Link href="/protein" className="text-blue-600 hover:text-blue-800 flex items-center">
          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Back to Search
        </Link>
      </div>

      {/* Main Content */}
      <div>{children}</div>
    </div>
  );
};

export default ProteinPageLayout;

// เรื่อง: สมัครงานตำแหน่ง Fullstack Software Engineer

// เรียน ฝ่ายทรัพยากรบุคคล
// บริษัท ฟันช์ จำกัด

// ข้าพเจ้ามีความสนใจสมัครงานในตำแหน่ง Fullstack Software Engineer ที่บริษัท ฟันช์ จำกัด ตามประกาศรับสมัครงานทางเพจ Facebook

// ข้าพเจ้าสำเร็จการศึกษาระดับปริญญาตรี สาขาวิทยาการคอมพิวเตอร์ คณะวิทยาศาสตร์และเทคโนโลยี จากมหาวิทยาลัยธรรมศาสตร์ ในระหว่างการฝึกงาน ได้พัฒนาโครงการที่เกี่ยวข้องกับ Web Development, API Development ในโปรเจคที่เกี่ยวกับเว็บไซต์ค้นหาเครื่องมือแพทย์ รวมถึงมีประสบการณ์การทำงานด้าน Fullstack Development โดยใช้ JavaScript, React.js, Express.js และ SQL/NoSQL Database

// หากต้องการข้อมูลเพิ่มเติม ข้าพเจ้ายินดีให้รายละเอียดเพิ่มเติมและเข้าร่วมการสัมภาษณ์ตามความสะดวกของท่าน หวังเป็นอย่างยิ่งว่าจะได้รับโอกาสร่วมงานกับบริษัท ฟันช์ จำกัด

// ขอแสดงความนับถือ
// พงศภัค ชื่นจันทน์แดง
// โทร: 083-xxx-xxxx
// อีเมล: pongpak.c@email.com




